export enum UserFlag {
    PLAYER__USER_HAS_DISMISSED_TOUR = 'PLAYER__USER_HAS_DISMISSED_TOUR_v1',
    PLAYER__USER_HAD_DOWNLOAD_POPOVER = 'PLAYER__USER_HAD_DOWNLOAD_POPOVER',
    PLAYER__USER_SAW_FIRST_TIME_CACHE_INFO = 'PLAYER__USER_SAW_FIRST_TIME_CACHE_INFO'
}
